import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
// import 'firebase/compat/database';
// import 'firebase/compat/auth';

const FIREBASE_API_KEY = process.env.FIREBASE_API_KEY;
const FIREBASE_PROJECT_ID = process.env.FIREBASE_PROJECT_ID;
const FIREBASE_DATABASE_URL = process.env.FIREBASE_DATABASE_URL;

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  projectId: FIREBASE_PROJECT_ID,
  databaseURL: FIREBASE_DATABASE_URL,
  authDomain: FIREBASE_PROJECT_ID + '.firebaseapp.com',
};

// firebaseApp.initializeApp(firebaseConfig);

export const firebase = initializeApp(firebaseConfig);
export const auth = getAuth();
export const database = FIREBASE_DATABASE_URL ? getDatabase() : null;
